import styled from 'styled-components';

export const AuthHeader = styled.div`
  position: absolute;
  left: 33px;
  top: 32px;
`;
